import { createRef } from '@wix/materializer'
import { GlobalImageQuality } from '@wix/thunderbolt-becky-types'
import { createPlanner } from './typeResolverUtils'

export type GlobalImageQualityViewItem = Pick<GlobalImageQuality, 'quality' | 'unsharpMask'>

export const fixDataItem = createPlanner<GlobalImageQuality, GlobalImageQualityViewItem>(
	({ quality, unsharpMask }: GlobalImageQuality) => ({ quality, unsharpMask })
)

export const createGlobalImagQualityRef = () =>
	createRef<GlobalImageQualityViewItem>(['data', 'document_data', 'IMAGE_QUALITY'])
